import React, { useEffect, useState } from "react";
import { IoIosPersonAdd } from "react-icons/io";
import { useAuth } from "../../context/Auth";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { RotatingLines } from "react-loader-spinner";

const RestoreBranchInventory = () => {
    const [branches, setBranches] = useState([]);
  const {requestWithAuth} = useAuth();
  const [selectedBranch, setSelectedBranch] = useState(null)
  const [restoring, setRestoring] = useState(false);

  const fetchBranches = async () => {
    try {
      const data = await requestWithAuth(
        `/company/branches/?pageSize=100`,
        "GET"
      );
      setBranches(data?.results);
    } catch (error) {
      console.error("Error fetching users data:", error);
    } finally {
    }
  };

  const restoreStock = async (e) => {
    e.preventDefault();
    Swal.fire({
      icon: "question",
      title: "Are you sure you want to restore the stock of this branch?",
      showDenyButton: true,
      confirmButtonText: "Yes Proceed!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setRestoring(true);
          const body = JSON.stringify({
            branch: selectedBranch
          });

          const data = await requestWithAuth(`/inventory/restore-stock/`, "POST", body, {
            "Content-Type": "application/json",
          });
        
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "The stock of this branch has been restored successfully",
          }).then(() => {
            window.location.reload()
          });
        } catch (error) {
          toast.error(error.response.data.message)
          if (error.response.data.error) {
            for (const property in error.response.data.error) {
              toast.error(
                `${property} error: ${error.response.data.error[property]}`
              );
            }
          }
          if (error.response.status === 500) {
            toast.error("Something went wrong!");
          }
        } finally {
          setRestoring(false);
        }
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  return (
    <div className="px-[20px]">
      <div className="py-[32px] flex items-center gap-3">
        <IoIosPersonAdd className="text-[19px]" />
        <h4 className="text-[19px]">
          <b>Branch</b> - Restore Branch Inventory
        </h4>
      </div>

      <div className="lg:w-[40%] mx-auto">
        <form onSubmit={(e)=>restoreStock(e)} className="">
          <div className="mb-[20px] border border-[#ddd] rounded-[3px] bg-white">
            <div className="p-[20px]">
              <h5 className="my-[2px] text-[17px]">Select Branch </h5>
            </div>
            <div className="p-[20px] pt-0">
              <div className="flex items-center gap-2 mb-[20px] pb-[10px] uppercase border-b border-[#e5e5e5]">
                <IoIosPersonAdd className="text-[12px]" />
                <label htmlFor="item" className="text-[12px] font-[500]">
                  Restore Branch Stock
                </label>
              </div>
              <div className="">
                <label htmlFor="" className="font-[600]">
                  Branch:
                </label>
                <select
                  onChange={(e) => setSelectedBranch(e.target.value)}
                  required
                  className="border border-[#ddd] rounded-[3px] h-[36px] w-full text-[#333] text-[13px] px-[12px] py-[7px]"
                  name=""
                  id=""
                >
                  <option value="">Select Branch</option>
                  {branches.map((branch, index) => (
                    <>
                      {!branch?.is_head_office && (
                        <option key={index} value={branch.id}>
                          {branch.name}
                        </option>
                      )}
                    </>
                  ))}
                </select>
              </div>
              <div className="flex justify-end">
              <div className="flex justify-end">
                {restoring ? (
                  <div className="bg-[#2195f3d9] flex items-center gap-2 px-[12px] py-[7px] text-[13px] rounded-[3px] mt-5 text-white">
                    <RotatingLines
                      visible={true}
                      height="16"
                      width="16"
                      color="black"
                      strokeColor="white"
                      strokeWidth="5"
                      animationDuration="0.75"
                      ariaLabel="rotating-lines-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />{" "}
                    Restoring
                  </div>
                ) : (
                  <button className="bg-[#2196F3] px-[12px] py-[7px] text-[13px] rounded-[3px] mt-5 text-white">
                    Submit
                  </button>
                )}
              </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RestoreBranchInventory;
